namespace $ {

	/** Registry membership only: writer counters stay in their original areas. */
	export class $shm_hitalama_map_history_storage_target_writers_shard extends $giper_baza_entity.with({
		Entries: $giper_baza_dict_to( $giper_baza_atom_bool ),
		Routing: $giper_baza_atom_bool,
	}) {
		static readonly capacity = 32

		ready() { return $shm_hitalama_map_history_storage_ready.settled(this) }

		branch( bit: number ) {
			return this.land().area_make( $mol_hash_string( `${this.link().str}:writer-registry:${bit}` ) )
				.Data( $shm_hitalama_map_history_storage_target_writers_shard )
		}

		contains( key: string, auto = false, depth = 0 ): boolean {
			this.ready()
			const entries = this.Entries()
			entries?.units()
			if( entries?.key( key ) ) return true
			if( auto && $mol_charset_encode(key).byteLength > 512 ) {
				throw new Error( 'Некорректный идентификатор автора истории' )
			}
			if( !this.Routing()?.val() ) {
				if( !auto ) return false
				if( (entries?.keys().length ?? 0) < $shm_hitalama_map_history_storage_target_writers_shard.capacity ) {
					// Membership is the key itself; no second value unit is needed.
					this.Entries(null)!.key( key, 'auto' )
					return true
				}
				this.Routing(null)!.val( true )
			}
			if( depth >= 128 ) throw new Error( 'Переполнен каталог авторов истории' )
			const hash = $mol_hash_string( `${Math.floor(depth/32)}:${key}` ) >>> 0
			return this.branch( (hash >>> (depth%32)) & 1 ).contains( key, auto, depth+1 )
		}

		@ $mol_mem
		members(): readonly string[] {
			this.units()
			const keys = (this.Entries()?.keys() ?? []).map( String )
			if( !this.Routing()?.val() ) return keys
			return [...new Set([ ...keys, ...this.branch(0).members(), ...this.branch(1).members() ])]
		}
	}

}
